let DropdownToggle = function(el){
    this.el = el;
    this.trigger = this.el.getElementsByClassName('js-dropdown-toggle-trigger')[0];
    this.menu = this.el.getElementsByClassName('js-dropdown-toggle-menu')[0];
    this.active = false;
    this.closetriggers = this.el.getElementsByClassName('js-dropdown-toggle-close-trigger');
    let self = this;
    
    document.addEventListener('click', function(el){
      if(el.target.classList.contains('js-dropdown-toggle-close-trigger')) {
        self.closeNavigation();
      }
    })
    this.trigger.addEventListener('click', function(){
      if (self.active) {
        self.closeNavigation();
      } else {
        self.openNavigation();
        
      }
    });
    window.addEventListener('click', function(event){
      if(!event.target.closest('.js-dropdown-toggle')) self.closeNavigation();
    });
    
  }
  DropdownToggle.prototype.closeNavigation = function() {
    
    this.menu.classList.remove('active');
    this.menu.setAttribute('aria-expanded', 'false');
    this.active = false;
  }

  DropdownToggle.prototype.openNavigation = function() {
    this.menu.classList.add('active');
    this.menu.setAttribute('aria-expanded', 'true');
    this.active = true;
    window.dispatchEvent(new Event("close_navs", {
      bubbles: true
    }));
  }
 

  let dropdown_toggle = document.getElementsByClassName('dropdown-toggle');
  for( let i=0; i<dropdown_toggle.length; i++) {
    let toggle = new DropdownToggle(dropdown_toggle[i]);
  }
